import React, { useState } from 'react';
import Modal from 'react-modal';
import './styles.scss';

const AddUnitRoleModal = ({ closeModal, handleAddUnitRole, addRoleData, roleLabels }) => {
  const handleClose = () => {
    closeModal();
  };

  const handleConfirm = () => {
    const payload = {
      time_type: 'two_weeks',
      scheduling_unit_id: addRoleData.unitId,
      role: addRoleData.type.toLowerCase(),
    };

    handleAddUnitRole(payload);
    handleClose();
  };

  return (
    <Modal className="modal-alert add-role-modal" isOpen onRequestClose={handleClose} contentLabel="Delete note modal" ariaHideApp={false}>
      <h2 className="modal-header">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="5" y="5" width="38" height="38" rx="19" fill="#F4EBFF" />
          <rect x="5" y="5" width="38" height="38" rx="19" stroke="#F9F5FF" strokeWidth="10" />
          <path
            d="M26.6667 17.3359V20.0026M21.3333 17.3359V20.0026M18 22.6693H30M19.3333 18.6693H28.6667C29.403 18.6693 30 19.2662 30 20.0026V29.3359C30 30.0723 29.403 30.6693 28.6667 30.6693H19.3333C18.597 30.6693 18 30.0723 18 29.3359V20.0026C18 19.2662 18.597 18.6693 19.3333 18.6693Z"
            stroke="#7F56D9"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        <button className="btn btn-icon" onClick={handleClose}>
          <i className="icon-icon-x"></i>
        </button>
      </h2>

      <div>
        <h3>Confirm Adding {addRoleData.type == 'Nurse' ? roleLabels.nurse_role_label : roleLabels.cna_role_label}</h3>
        <p style={{ marginTop: '30px', color: '#101828' }}>Add the line for these 2 weeks</p>
      </div>
      <div className="modal-footer">
        <button className="btn btn-outline" onClick={handleClose}>
          Cancel
        </button>
        <button
          className="btn"
          onClick={(e) => {
            e.stopPropagation();
            handleConfirm();
          }}
        >
          Confirm
        </button>
      </div>
    </Modal>
  );
};

export default AddUnitRoleModal;
